<div class="code-display">
  <digit [digit]="current[i]" *ngFor="let digit of code; let i = index" [selected]="currentSelected==i"
    (onDigitClick)="select(i)" [class]="'code '" [codification]="codification" [duplicate]="hasDuplicates(i)">
  </digit>

</div>




<div class="keypad-container" *ngIf="keypadVisible" [@bottomIn]>
  <div class="keypad" >
    <digit [digit]="i" *ngFor="let digit of codification?.digits; let i = index" (onDigitClick)="setChoice($event)"
      [codification]="codification" [class]="'keypad-button'">
    </digit>

  </div>
</div>
